/**
 * useChatHandlers — handlers de nova conversa e transferência.
 */
import { Lead } from '../../../types';
import { leadHistoryService } from '../../../services/leadHistoryService';

interface UseChatHandlersProps {
    startNewConversation: (number: string, name: string) => void;
    transferConversation: (conversationId: string, userId: string) => Promise<boolean>;
    activeConversationId: string | null;
    leads: Lead[];
    organizationId?: string;
}

export const useChatHandlers = ({
    startNewConversation,
    transferConversation,
    activeConversationId,
    leads,
    organizationId,
}: UseChatHandlersProps) => {
    const handleNewConversation = (number: string, name: string) => {
        startNewConversation(number, name);

        const cleanNumber = number.replace(/\D/g, '');
        const lead = leads.find((l) => {
            const lPhone = (l.whatsApp || '').replace(/\D/g, '');
            return Boolean(lPhone && (lPhone.includes(cleanNumber) || cleanNumber.includes(lPhone)));
        });

        if (lead && organizationId) {
            leadHistoryService.addEvent({
                leadId: lead.id,
                organizationId,
                type: 'conversation_started',
                description: 'Nova conversa iniciada',
                newValue: name || number,
            });
        }
    };

    const handleTransfer = async (userId: string) => {
        if (activeConversationId) {
            await transferConversation(activeConversationId, userId);
        }
    };

    return {
        handleNewConversation,
        handleTransfer,
    };
};
